import { useEffect, useState } from "react"
import Select from 'react-select'
import Header from "../../../../../../Components/Header/Header"
import Sidebar from "../../../../../../Components/Sidebar/Sidebar"
import DeletePopup from "../../../GardenPopup/DeletePopup"
import { useSearchParams } from "react-router-dom"
import { useAuthState } from "../../../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment";
import { WardNameDataDDL } from "../../../../../../Components/CommonDDL/WardNameDataDDL"
import { ServiceTypeDataDDL } from "../../../../../../Components/CommonDDL/ServiceTypeDataDDL"

import { Pegination } from "../../../../../../Components/Pegination/Pegination"
import ViewURL from "../../../../../../Components/ViewURL/ViewURL"
import { CustomerServiceExportTableDataAPI, CustomerServiceMasterDeleteAPI, CustomerServiceTableDataAPI } from "../../../../../../Redux/SeverageDashboardSlice/AssignedWorkCustomerServicesSlice"
import { PreventiveCustomerServiceExportData } from "./PreventiveCustomerServiceExportData"
import { TableDeleteNote } from "../../../../../../Components/Note/TableDeleteNote"
import { Loading } from "../../../../../../Helper/Loading"
import { toastErrorr } from "../../../../../../Helper/ToastMessage"
// import { ServicesMasterDeleteAPI } from "../../../../../../Redux/SeverageDashboardSlice/ServicesMasterSlice"


export default function PreventiveCustomerServiceData() {

    const [DeletePopupShow, setDeletePopupShow] = useState()

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails

    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let M_SW_WorkTypeID = searchParams.get('M_SW_WorkTypeID')
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).date(1).format('YYYY-MM-DD'));
    const [FromDate, setFromDate] = useState(date ? moment(date).startOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(date ? date : moment().format('YYYY-MM-DD'))

    // const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    // const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)

    const [Heading, setHeading] = useState('')
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [ShowImagePopup, setshowImagePopup] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)

    const [PDFUrl, setPDFUrl] = useState('')

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    // const [Month, setMonth] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })
    const [ServiceType, setServiceType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleShowImage = (Imageurl, heading) => {
        setshowImagePopup(true)
        setImagePopUpData(Imageurl)
        setHeading(heading)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }

    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        setServiceType({
            ...ServiceType,
            ID: 0,
            Label: 'Select...'
        })
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
    }

    const handleGetPDFUrl = (pdfUrl) => {
        // console.log('pdfUrl',pdfUrl)
        if (pdfUrl && pdfUrl != '') {
            window.open(pdfUrl)
            // setPDFUrl(pdfUrl)
        } else {
            toastErrorr("PDF not found")
        }
    }

    const handleOpenPdf = () => {
        window.open(PDFUrl)
    }

    const handleGetPDF = () => {
        // console.log(FinancialYear, FinancialYearID, FinancialYearLabel)
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_SW_LocationID: 0,
            M_SW_ServiceTypeID: ServiceType.ID,
            M_UserID: UserID,
            Flag: ApiFlag,
            token: token,
            From: From,
            To: To,
            searchName: searchName,
            handleGetPDFUrl: handleGetPDFUrl
        }
        dispatch(CustomerServiceTableDataAPI({ data }))
    }

    // const { tableData, isLoading } = useSelector(state => state.CustomerServiceTableData)

    useEffect(() => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_SW_LocationID: 0,
            M_SW_ServiceTypeID: ServiceType.ID,
            M_UserID: UserID,
            Flag: ApiFlag,
            token: token,
            From: From,
            To: To,
            searchName: searchName,
            handleCustomerServiceExport: handleCustomerServiceExport
        }
        dispatch(CustomerServiceTableDataAPI({ data }))
    }, [IsPost, To, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.CustomerServiceTableData)

    const handleCustomerServiceExport = () => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_SW_LocationID: 0,
            M_SW_ServiceTypeID: ServiceType.ID,
            M_UserID: UserID,
            Flag: ApiFlag,
            token: token,
            From: '1',
            To: '99999',
            searchName: searchName,
        }
        dispatch(CustomerServiceExportTableDataAPI({ data }))
    }
    // , [IsPost, isSearch, IsClear])

    const { ExportTableData, isExportLoading } = useSelector(state => state.CustomerServiceExportTableData)

    const handleDeleteApi = (item) => {
        const data = {
            T_SW_CustomerServicesID: item.t_sW_CustomerServicesID,
            M_UserID: UserID,
            token: token,
            Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(CustomerServiceMasterDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.ServicesMasterDeleteData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [IsPost, WardName.ID])

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })

    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                // DashboardHeading="Sewerage Maintainance"
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName} />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId} />
                <div className="content">
                    <div className="data_mob">
                        <div className="row m-1 py-1 pb-4 master_border">
                            <div className="col-9">
                                <h5 className="ps-1 py-1">Customer Services {searchName}</h5>
                            </div>
                            <div className="col-3">
                                {
                                    tableData && tableData.table && tableData.table.length > 0 ?
                                        <button type="button"
                                            className="btn btn-danger float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                                            // className="btn btn-outline-danger float-end mr-1 mb-2 px-2"
                                            onClick={handleGetPDF}
                                        ><i className='fas fa-file-pdf mx-2'></i>PDF</button>
                                        :
                                        <></>
                                }

                                {
                                    isExportLoading ?
                                        <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                            <i
                                                className="fa fa-refresh fa-spin"
                                                style={{ marginRight: "5px" }}
                                            />Loading</button>
                                        :
                                        tableData && tableData.table && tableData.table.length > 0 &&
                                        <PreventiveCustomerServiceExportData
                                            ExcelData={ExportTableData}
                                            name={`Customer Services ${searchName}`}
                                            searchName={searchName}
                                            FromDate={FromDate}
                                            ToDate={ToDate}
                                        />
                                }
                            </div>

                            <div className="row m-0 pt-md-1 pt-lg-1">
                                <div className="col-12 py-2  rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">
                                        <div className="row rounded2">
                                            <div className="col-12 col-md-6 col-lg-2 ">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"> <b>From Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="FromDate"
                                                        value={FromDate}
                                                        onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-2 ">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>To Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="ToDate"
                                                        value={ToDate}
                                                        onChange={(e) => setToDate(e.target.value)}
                                                        min={FromDate}
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-12 col-md-6 col-lg-2 ">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                />
                                            </div>
                                            <div className="col-12 col-lg-3 col-md-6" >
                                                <ServiceTypeDataDDL
                                                    ServiceType={ServiceType}
                                                    setServiceType={setServiceType}

                                                />

                                            </div>

                                            <div className="col-12 col-md-3 col-lg-2 mt-lg-4 mt-md-4 d-md-flex" >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>
                                        </div>
                                        {
                                            searchName == "Pending" ?
                                                <>
                                                    <TableDeleteNote />
                                                </>
                                                : ''

                                        }
                                        <div className="row mob_table table-responsive pt-2">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Location</th>
                                                        <th>Service Type</th>
                                                        <th>Assign Date</th>
                                                        {
                                                            searchName == "Completed" ?
                                                                <>
                                                                    <th>Work Date</th>
                                                                </>
                                                                : ''
                                                        }
                                                        <th>Before Photo</th>
                                                        {
                                                            searchName == "Completed" ?
                                                                <>
                                                                    <th>After Photo</th>
                                                                </>
                                                                : ''
                                                        }

                                                        {
                                                            searchName == "Pending" ?
                                                                <>
                                                                    <th>Action</th>
                                                                </>
                                                                : ''
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => {
                                                            return (
                                                                <tr>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    <td>{item.swLocation ? item.swLocation : '-'}</td>
                                                                    <td>{item.serviceTypeName ? item.serviceTypeName : '-'}</td>
                                                                    <td>{item.workAssingDate ? item.workAssingDate : '-'}</td>
                                                                    {
                                                                        searchName == "Completed" ?
                                                                            <>
                                                                                <td>{item.workDoneDate ? item.workDoneDate : '-'}</td>
                                                                            </>
                                                                            : ''
                                                                    }


                                                                    <td style={{ textAlign: "center" }}>
                                                                        {
                                                                            (item.beforePhoto == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <>
                                                                                    <i className="fa-solid fa-eye" title='View'
                                                                                        style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                        onClick={() => handleShowImage(item.beforePhoto, 'Start Photo')}
                                                                                    ></i>
                                                                                </>
                                                                        }
                                                                    </td>

                                                                    {
                                                                        searchName == "Completed" ?
                                                                            <>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    {
                                                                                        (item.afterPhoto == null) ?
                                                                                            <span>-</span>
                                                                                            :
                                                                                            <>
                                                                                                <i className="fa-solid fa-eye" title='View'
                                                                                                    style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                                    onClick={() => handleShowImage(item.afterPhoto, 'Start Photo')}
                                                                                                ></i>
                                                                                            </>
                                                                                    }
                                                                                </td>
                                                                            </>
                                                                            : ''
                                                                    }

                                                                    {
                                                                        searchName == "Pending" && ((item.workAssingDate) == moment().format('DD/MM/YYYY')) ?
                                                                            <>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    <span>
                                                                                        <DeletePopup
                                                                                            open={DeletePopupShow}
                                                                                            handleDeleteApi={handleDeleteApi}
                                                                                            item={item}
                                                                                        />
                                                                                    </span>
                                                                                </td>
                                                                            </>
                                                                            : ''
                                                                    }
                                                                    {/* <td style={{ textAlign: "center" }}>
                                                                        <span>
                                                                            <DeletePopup
                                                                                open={DeletePopupShow}
                                                                                handleDeleteApi={handleDeleteApi}
                                                                                item={item}
                                                                            />
                                                                        </span>
                                                                    </td> */}
                                                                </tr>
                                                            )
                                                        })
                                                            :
                                                            <td colSpan={15}>No data found</td>
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {
                ShowImagePopup &&
                <ViewURL
                    Heading={Heading}
                    ImagePopUpData={ImagePopUpData}
                    setshowImagePopup={setshowImagePopup}
                />
            }
        </div>
    )
}